/** 分数运算 */

type TFuc = (a: number, b: number) => number

const reduce = (numerator: number, denominator: number) => {
  const gcd: TFuc = (a: number, b: number) => {
    return b ? gcd(b, a % b) as number : a
  }
  const num = gcd(numerator, denominator)
  return `${numerator / num}/${denominator / num}`
}

// 分数相加
const add = (a: string, b: string) => {
  if (!b) {
    return a
  } else if (!a) {
    return b
  }
  const arr0 = a.split('/')
  const arr1 = b.split('/')
  const denominator = parseInt(arr0[1]) * parseInt(arr1[1])
  const numerator = parseInt(arr0[0]) * parseInt(arr1[1]) + parseInt(arr1[0]) * parseInt(arr0[1])

  return denominator === numerator ? '1' : reduce(numerator, denominator)
}

// 分数相减
const subtract = (a: string, b: string) => {
  if (!b) {
    return a
  } else if (!a) {
    return `-${a}`
  }
  const arr0 = a.split('/')
  const arr1 = b.split('/')
  const denominator = parseInt(arr0[1]) * parseInt(arr1[1])
  const numerator = parseInt(arr0[0]) * parseInt(arr1[1]) - parseInt(arr1[0]) * parseInt(arr0[1])

  return numerator && denominator ? reduce(numerator, denominator) : ''
}

// 分数相乘
const multiply = (a: string, b: string) => {
  if (a === '1' || b === '1') {
    return a === '1' ? b : a
  }
  if (a === '0' || b === '0') {
    return '0'
  }
  const arr0 = a.split('/')
  const arr1 = b.split('/')
  const denominator = parseInt(arr0[1]) * parseInt(arr1[1])
  const numerator = parseInt(arr0[0]) * parseInt(arr1[0])

  return denominator === numerator ? '1' : reduce(numerator, denominator)
}

const divide = (a: string, b: string) => {
  if (b === '0') {
    return 'Infinity'
  }
  if (b === '1') {
    return a
  }
  const reverseB = b.split('/').reverse().join('/')
  if (a === '1') {
    return reverseB
  }
  return multiply(a, reverseB)
}

export default {
  add,
  subtract,
  multiply,
  divide,
}
